import ApiService from '@/common/api.service';
import * as action from '@/store/action.types';
import * as mutation from '@/store/mutation.types'
import {
  GET_RELATED_COPARENTS_URL,
  GET_CASES_URL,
  RECURRING_EXPENSE_INTERVAL_UNITS_API
} from '@/constants/ApiConstants';

const state = {
  coparents: [],
  cases: []
};

const getters = {
  coparents: (state) => state.coparents,
  cases: (state) => state.cases,
};

const actions = {
  [action.GET_RELATED_COPARENTS]({ commit }) {
    return new Promise((resolve, reject) => {
      ApiService
      .get(GET_RELATED_COPARENTS_URL)
      .then((response) => {
        response.data.data.forEach(coparent => {
          let splitCoparentName = coparent.name.trim().match(/\S+/g);
          coparent.shortenedName = splitCoparentName[0] + ' ' + splitCoparentName[1].substring(0, 1) + '.';
        })
        commit(mutation.SET_COPARENTS, response.data.data)
        return resolve(response)
      })
      .catch(error => {
        return reject(error)
      })
    })
  },
  [action.GET_CASES]({ commit }) {
    return new Promise((resolve, reject) => {
      ApiService
      .get(GET_CASES_URL)
      .then((response) => {
        response.data.data.coparents.forEach(coparent => {
          let splitCoparentName = coparent.coparentName.trim().match(/\S+/g);
          coparent.shortenedName = splitCoparentName[0] + ' ' + splitCoparentName[1].substring(0, 1) + '.';
        })
        commit(mutation.SET_CASES, response.data.data.coparents)
        return resolve(response)
      })
      .catch(error => {
        return reject(error)
      })
    })
  },
  [action.RECURRING_EXPENSE_INTERVAL_UNITS]() {
    return ApiService.get(RECURRING_EXPENSE_INTERVAL_UNITS_API);
  }
};

const mutations = {
  [mutation.SET_COPARENTS] (state, coparents) {
    state.coparents = coparents
  },
  [mutation.SET_CASES] (state, cases) {
    state.cases = cases
  },
};

export default {
  state,
  actions,
  getters,
  mutations
}
